import React, { useContext, useMemo } from 'react';
import PropTypes from 'prop-types';
import useExtendedQuery from '../../hooks/useExtendedQuery';
import AuctionDetailTab from './AuctionDetailTab';
import BaseUrlContext from '../../contexts/BaseUrlContext';
import { auctionPropertiesType } from '../../types';
import Spinner from '../Spinner';
import { AUCTION_DETAIL, ON_AUCTION_CHANGED } from '../../graphql/auctions';
import useExtendedSubscription from '../../hooks/useExtendedSubscription';
import Error from '../errors/Error';

AuctionDetail.propTypes = {
    auctionId: PropTypes.number.isRequired,
    auctionProps: auctionPropertiesType.isRequired,
};

function AuctionDetail(props) {
    const {
        auctionId,
        auctionProps,
    } = props;
    const baseUrl = useContext(BaseUrlContext);
    const variables = useMemo(() => ({
        auctionId,
    }), [auctionId]);
    const {
        loading,
        error,
        data,
        refetch,
    } = useExtendedQuery(AUCTION_DETAIL, {
        variables,
        variablesToUrl: false,
    });
    useExtendedSubscription(ON_AUCTION_CHANGED, {
        refetch,
        refetchOnOwnResponse: true,
        refetchVariables: variables,
        dataProperty: 'auctionChanged',
    });
    let result;
    if (loading) {
        result = <Spinner className="auction-detail-loading" />;
    } else if (error) {
        result = <Error className="auction-detail-error" error={error} />;
    } else {
        result = (
            <AuctionDetailTab
                auction={data.auctionDetail}
                auctionProps={auctionProps}
            />
        );
    }
    return (
        <BaseUrlContext.Provider value={`${baseUrl}/${auctionId}`}>
            {result}
        </BaseUrlContext.Provider>
    );
}

export default AuctionDetail;
